// Import URI.js library (you'll need to include this library in your theme)
// Example: <script src="https://cdnjs.cloudflare.com/ajax/libs/URI.js/1.19.11/URI.min.js"></script>

jQuery(document).ready(function($) {
  $('span.top_btn1').on('click', function() {
    var get_lower = $('.top_btn2.active').data('pr');
    if ($(this).hasClass('btn_all')) {
      $('.rgt_btn_majestic').removeClass('active');
      $('.left_btn_boaz').removeClass('active');
      $('.btn_all').addClass('active');
      if (get_lower == 'in-stock') {
        $('#product-grid .grid__item.no-stock').each(function() {
          $(this).hide();
        });
        $('#product-grid .grid__item.in-stock').each(function() {
          $(this).show();
        });
      } else if (get_lower == 'no-stock') {
        $('#product-grid .grid__item.no-stock').each(function() {
          $(this).show();
        });
        $('#product-grid .grid__item.in-stock').each(function() {
          $(this).hide();
        });
      } else if (get_lower == 'All') {
        $('#product-grid .grid__item').each(function() {
          $(this).show();
        });
      }

    } else if ($(this).hasClass('left_btn_boaz')) {
      $('.rgt_btn_majestic').removeClass('active');
      $('.btn_all').removeClass('active');
      $('.left_btn_boaz').addClass('active');
      if (get_lower == 'no-stock') {
        $('#product-grid .grid__item.no-stock.onlyBoaz').each(function() {
          $(this).show();
        });
        $('#product-grid .grid__item.no-stock.onlyMajestic').each(function() {
          $(this).hide();
        });
        $('#product-grid .grid__item.in-stock.onlyBoaz').each(function() {
          $(this).hide();
        });
        $('#product-grid .grid__item.in-stock.onlyMajestic').each(function() {
          $(this).hide();
        });
      } else if (get_lower == 'in-stock') {
        $('#product-grid .grid__item.in-stock.onlyBoaz').each(function() {
          $(this).show();
        });
        $('#product-grid .grid__item.in-stock.onlyMajestic').each(function() {
          $(this).hide();
        });
        $('#product-grid .grid__item.no-stock.onlyBoaz').each(function() {
          $(this).hide();
        });
        $('#product-grid .grid__item.no-stock.onlyMajestic').each(function() {
          $(this).hide();
        });
      } else if (get_lower == 'All') {
        $('#product-grid .grid__item.in-stock.onlyBoaz').each(function() {
          $(this).show();
        });
        $('#product-grid .grid__item.in-stock.onlyMajestic').each(function() {
          $(this).hide();
        });
        $('#product-grid .grid__item.no-stock.onlyBoaz').each(function() {
          $(this).show();
        });
        $('#product-grid .grid__item.no-stock.onlyMajestic').each(function() {
          $(this).hide();
        });
      }
    } else if ($(this).hasClass('rgt_btn_majestic')) {
      $('.left_btn_boaz').removeClass('active');
      $('.btn_all').removeClass('active');
      $('.rgt_btn_majestic').addClass('active');
      if (get_lower == 'no-stock') {
        $('#product-grid .grid__item.no-stock.onlyMajestic').each(function() {
          $(this).show();
        });
        $('#product-grid .grid__item.no-stock.onlyBoaz').each(function() {
          $(this).hide();
        });
        $('#product-grid .grid__item.in-stock.onlyBoaz').each(function() {
          $(this).hide();
        });
        $('#product-grid .grid__item.in-stock.onlyMajestic').each(function() {
          $(this).hide();
        });
      } else if (get_lower == 'in-stock') {
        $('#product-grid .grid__item.in-stock.onlyMajestic').each(function() {
          $(this).show();
        });
        $('#product-grid .grid__item.in-stock.onlyBoaz').each(function() {
          $(this).hide();
        });
        $('#product-grid .grid__item.no-stock.onlyBoaz').each(function() {
          $(this).hide();
        });
        $('#product-grid .grid__item.no-stock.onlyMajestic').each(function() {
          $(this).hide();
        });
      } else if (get_lower == 'All') {
        $('#product-grid .grid__item.in-stock.onlyMajestic').each(function() {
          $(this).show();
        });
        $('#product-grid .grid__item.in-stock.onlyBoaz').each(function() {
          $(this).hide();
        });
        $('#product-grid .grid__item.no-stock.onlyMajestic').each(function() {
          $(this).show();
        });
        $('#product-grid .grid__item.no-stock.onlyBoaz').each(function() {
          $(this).hide();
        });
      }
    }

  });
  $('span.top_btn2').on('click', function() {
    if ($(this).hasClass('left_btn_all')) {
      $('.left_btn_mto').removeClass('active');
      $('.left_btn_instock').removeClass('active');
      $('.left_btn_all').addClass('active');
      var get_type = $('.top_btn1.active').data('pr');
      $('#product-grid .grid__item').each(function() {
        if (get_type == 'All') {
          if ($(this).hasClass('onlyBoaz') || $(this).hasClass('onlyMajestic')) {
            $(this).show();
          }
        } else if (get_type == 'Boaz') {
          if ($(this).hasClass('onlyBoaz')) {
            $(this).show();
          } else {
            $(this).hide();
          }
        } else if (get_type == "Majestic") {
          if ($(this).hasClass('onlyMajestic')) {
            $(this).show();
          } else {
            $(this).hide();
          }
        }
      });
    } else if ($(this).hasClass('left_btn_mto')) {
      $('.left_btn_all').removeClass('active');
      $('.left_btn_instock').removeClass('active');
      $('.left_btn_mto').addClass('active');
      var get_type = $('.top_btn1.active').data('pr');
      $('#product-grid .grid__item').each(function() {
        if (get_type == 'Boaz') {
          if ($(this).hasClass('onlyBoaz') && $(this).hasClass('no-stock')) {
            $(this).show();
          } else {
            $(this).hide();
          }
        } else if (get_type == "Majestic") {
          if ($(this).hasClass('onlyMajestic') && $(this).hasClass('no-stock')) {
            $(this).show();
          } else {
            $(this).hide();
          }
        } else if (get_type == "All") {
          if ($(this).hasClass('no-stock')) {
            $(this).show();
          } else {
            $(this).hide();
          }
        }
      });
    } else if ($(this).hasClass('left_btn_instock')) {
      $('.left_btn_all').removeClass('active');
      $('.left_btn_mto').removeClass('active');
      $('.left_btn_instock').addClass('active');
      var get_type = $('.top_btn1.active').data('pr');
      $('#product-grid .grid__item').each(function() {
        if (get_type == 'Boaz') {
          if ($(this).hasClass('onlyBoaz') && $(this).hasClass('in-stock')) {
            $(this).show();
          } else {
            $(this).hide();
          }
        } else if (get_type == "Majestic") {
          if ($(this).hasClass('onlyMajestic') && $(this).hasClass('in-stock')) {
            $(this).show();
          } else {
            $(this).hide();
          }
        } else if (get_type == "All") {
          if ($(this).hasClass('in-stock')) {
            $(this).show();
          } else {
            $(this).hide();
          }
        }
      });
    }
  });

  // Function to set filter parameter in URL
  function setFilterParameter(filter) {
    const uri = URI(window.location.href);
    uri.setSearch('filter', filter);
    window.location.href = uri.toString();
  }

  // Function to simulate click based on URL parameter
  function filterFromURL() {
    const urlParams = new URLSearchParams(window.location.search);
    const filter = urlParams.get('filter');
    if (filter === 'boaz') {
      setFilterParameter('boaz'); // Set the parameter and reload
    } else if (filter === 'majestic') {
      setFilterParameter('majestic'); // Set the parameter and reload
    }
  }

// Function to apply filter based on URL parameter
function filterFromURL() {
  const urlParams = new URLSearchParams(window.location.search);
  const filter = urlParams.get('filter');

  if (filter === 'boaz') {
    // Trigger the click event programmatically
    $('#filter-boaz').trigger('click'); 

  } else if (filter === 'majestic') {
    // Trigger the click event programmatically
    $('#filter-majestic').trigger('click'); 
  }
}

// Call the function when the page loads
window.addEventListener('DOMContentLoaded', filterFromURL);

});